import { Navbar, Nav, Container, Stack } from "react-bootstrap";
import imd from "../Assets/imd.png";
import { useLocation, Link } from "react-router-dom";
import Somaiya_small from "../Assets/Somaiya.svg";
import useMediaQuery from "@mui/material/useMediaQuery";

function Navigationbar() {
  const match = useMediaQuery("(max-width: 458px)");
  const location = useLocation();

  return (
    <Navbar bg="light" expand="md" sticky="top">
      <Container fluid>
        <Navbar.Brand className="Logo" as={Link} to="/">
          <Stack direction="horizontal" gap={match ? 2 : 3}>
            <img
              alt=""
              src={imd}
              width="34px"
              height="63px"
              style={{ width: match ? 25.5 : 34, height: match ? 47.25 : 63 }}
            />
            <img
              className="Somaiya_logo"
              alt=""
              src={Somaiya_small}
              style={{ width: match ? 36 : 48 }}
            />
            Heatwave Watch System
          </Stack>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              className={
                location.pathname === "/" ? "Nav_menu1 active" : "Nav_menu1"
              }
              as={Link}
              to="/"
            >
              Heat Watch
            </Nav.Link>
            <Nav.Link
              className={
                location.pathname === "/Maximum_Temperature"
                  ? "Nav_menu2 active"
                  : "Nav_menu2"
              }
              as={Link}
              to="/Maximum_Temperature"
            >
              Maximum Temperature
            </Nav.Link>
            <Nav.Link
              className={
                location.pathname === "/About"
                  ? "Nav_menu3 active"
                  : "Nav_menu3"
              }
              as={Link}
              to="/About"
            >
              About
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigationbar;
